import React from 'react';
import { compose } from 'redux';
import anime from 'animejs/lib/anime.es.js';

import j1 from './../../assets/img/journal/j1.jpg';
import j2 from './../../assets/img/journal/j2.jpg';
import j3 from './../../assets/img/journal/j3.jpg';
import j4 from './../../assets/img/journal/j4.jpg';
import j5 from './../../assets/img/journal/j5.jpg';
import j6 from './../../assets/img/journal/j6.jpg';
import Index from './_index';


class Journals extends React.Component {
    constructor(props) {
        super(props);
        setTimeout(() => {
            window.scrollTo(1000, 0);
        }, 300);
    }
    componentdidupdate(){
        setTimeout(() => {
            window.scrollTo(1000, 0);
        }, 300);
    }

    componentDidMount(){
      
        var hHeight = document.querySelector('header').clientHeight;
        var tl = anime.timeline();

        function parallax() {
            [].forEach.call(document.querySelectorAll("[parallax]"), function(e) {
                var tl = anime.timeline({
                        autoplay: false,
                    }),
                    target = e.getAttribute("parallax-target") || null;
                e.getAttribute("parallax").split(/[,\s]+(?={)/).forEach(function(v) {
                    var v = eval("(" + v + ")");
                    v.targets = e;
                    v.easing = "linear";
                    tl.add(v);
                });
                if (target) {
                    Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector);
                    var a = e;
                    while (a != null) {
                        if (a.matches(target)) {
                            e = a;
                            break;
                        }
                        a = a.parentElement;
                    }
                }
                var setup = function() {
                    requestAnimationFrame(function() {
                        if (window.innerWidth > e.getAttribute("parallax-disable")) {
                            var bound = e.getBoundingClientRect();
                            var wHeight = window.innerHeight;
                            if (e.hasAttribute("parallax-center")) {
                                if (bound.top < wHeight && bound.bottom > 0) tl.seek(tl.duration * ((wHeight - bound.top) / (wHeight + bound.height)).toFixed(3))
                                else if (bound.top >= wHeight) tl.seek(0)
                                else if (bound.bottom <= 0) tl.seek(tl.duration);
                            } else {
                                if (bound.top < wHeight && bound.top > hHeight) tl.seek(tl.duration * ((wHeight - bound.top) / (wHeight - hHeight)).toFixed(3))
                                else if (bound.top >= wHeight) tl.seek(0.01)
                                else if (bound.top <= hHeight) tl.seek(tl.duration);
                            }
                        } else {
                            if (e.hasAttribute("style")) {
                                e.removeAttribute("style");
                            }
                        }
                    });
                }
                setup();
                window.addEventListener("scroll", setup);
            });
        }
       
        tl.add({
            targets: "figure",
            opacity: 1,
            translateY: ["25%", 0],
            delay: function(o, i) {
                return 250 * i;
            },
            easing: "easeOutCubic",
            offset: "-=1000"
        });

        if (document.querySelectorAll("[parallax]")) parallax();
        setTimeout(() => {
            window.scrollTo(100, 0);
        }, 300);
        
         // TITLES
        tl.add({
            targets: "article",
            opacity: 1,
            easing: "easeOutCubic",
            offset: "-=1000"
        });

        var titles = document.querySelectorAll('.journal--articles article');
        var figs = document.querySelectorAll('.journal--figures figure');

        titles[0].classList.add("active");
        titles[0].style['opacity'] = 1;

        [...figs].forEach((item, index) => {   
            if(index > 0) {
                let elem = item.querySelector('img').style['opacity'] = 0.5;
            }
        });

        let _this = this;

        window.addEventListener('scroll', function() {
                
            if(document.querySelector('.mole__journal--insta')){
                let elementTop = document.querySelector('main > .mole__menu').getBoundingClientRect().height;
                let windowHeight = window.innerHeight;
                let viewportTop = document.documentElement.scrollTop;
                let pageHeight = document.body.clientHeight;
                let jArticles = document.querySelector('.journal--articles');
                let pageHeading = document.querySelector('.--title');

                if((viewportTop + windowHeight ) >= (pageHeight - elementTop)){
                    jArticles.style['opacity'] = 0;
                }
                else{
                    jArticles.style['opacity'] = 1;
                }

                if((viewportTop + (windowHeight / 2.5) ) >= (pageHeight - elementTop)){
                    pageHeading.style['opacity'] = 0;
                }
                else{
                    pageHeading.style['opacity'] = 1;
                }


                
            }
               
            _this.handleScroll()
            
        });
        
        [...figs].forEach((item, index) => {   
            let elem = item.querySelector('img');
            elem.addEventListener('mouseenter',(e) =>{
                e.preventDefault();
                let figIndex = e.currentTarget.parentElement.dataset.index;

                [...figs].forEach((item, index) => {   
                    let elem = item.querySelector('img').style['opacity'] = 0.5;
                });

                elem.style['opacity'] = 1;

                [...titles].forEach((item, key) => {
                    item.style['opacity'] = 1;
                    item.classList.remove('active');
                    if(Number(key) === Number(figIndex)){
                       item.classList.add('active')
                    }
               })
            })
            item.addEventListener('mouseleave',(e) =>{
                //console.log(1)
                e.preventDefault();
                _this.handleScroll()
            })
        })
        
    }    
    handleScroll(){
        var titles = document.querySelectorAll('.journal--articles article');
        var figs = document.querySelectorAll('.journal--figures figure');
        //Filter out all figures below mid window
        let actvFigsArr = [...figs].filter((fig, index) => {
            fig.querySelector('img').style['opacity'] = 0.5;
            let figBottom = fig.getBoundingClientRect().bottom;
            let windowHeight = window.innerHeight
            || document.documentElement.clientHeight
            || document.body.clientHeight;
            let mid = Number(windowHeight)/2;
            if (figBottom >= mid) return this;
        })
        //Index of the first one, considered as active
        let index = actvFigsArr.length ? actvFigsArr[0].dataset.index : 0;
        figs[index].querySelector('img').style['opacity'] = 1;
        //Add active class to index of active figure 
        [...titles].forEach((item, key) => {
             item.style['opacity'] = 1;
            item.classList.remove('active');
            if(Number(key) === Number(index)){
                item.classList.add('active')
            }
        })
        //Remove active class if scroll area overlaps the footer menu
        let lastTitle = titles[titles.length-1];
        if(lastTitle){
             let lastTitleBottom = lastTitle.getBoundingClientRect().bottom;
             let footerMenu = document.querySelectorAll('.mole__menu')[0];
             let footerMenuTop = footerMenu.getBoundingClientRect().top;
             if(footerMenuTop <= lastTitleBottom){
                 [...titles].forEach((item, key) => {
                     item.classList.remove('active');
                     item.style['opacity'] = 0;
                 })
             }
        }  
    }
    render() {
        return (
            <section className="mole__journal--insta-2">
                <div className="main-container">
                    <div className="inner-container">
                        <h2 className="font-lg-head c-general w-100 --title">Journal</h2>
                        <div className="w-100">
                            <div className="journal--articles">
                                <article>
                                    <h6 className="c-general">19.10.20</h6>
                                    <p>Preview of a new holiday house on the
                                    Norfolk coast. Architect Susie Newman
                                    on hand to assist @nickguttridge. Brick,
                                    flint, timber and Corten. Project team:
                                    Meredith Bowles, Sasha Edmonds, Alice
                                    Hamlin. Engineering @jpchickpartnersltd
                                    Rent from @freeholders7</p>
                                </article>

                                <article>
                                    <h6 className="c-general">20.10.20</h6>
                                    <p>Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs.</p>
                                </article>

                                <article>
                                    <h6 className="c-general">22.10.20</h6>
                                    <p>Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs.</p>
                                </article>

                                <article>
                                    <h6 className="c-general">23.10.20</h6>
                                    <p>Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs.</p>
                                </article>

                                <article>
                                    <h6 className="c-general">24.10.20</h6>
                                    <p>Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs.</p>
                                </article>

                                <article>
                                    <h6 className="c-general">25.10.20</h6>
                                    <p>Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs.</p>
                                </article>
                                
                            </div>

                            <div className="journal--figures">
                                <figure data-index="0"><img parallax="{translateY: ['-20vh', '0']}"  src={j1}/></figure>
                                <figure data-index="1"><img parallax="{translateY: ['-20vh', '0']}"  src={j2}/></figure>
                                <figure data-index="2"><img parallax="{translateY: ['-20vh', '0']}"  src={j3}/></figure>
                                <figure data-index="3"><img parallax="{translateY: ['-20vh', '0']}"  src={j4}/></figure>
                                <figure data-index="4"><img parallax="{translateY: ['-20vh', '0']}"  src={j5}/></figure>
                                <figure data-index="5"><img parallax="{translateY: ['-20vh', '0']}"  src={j6}/></figure>
                            </div>
                   
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
export default Journals;



// WEBPACK FOOTER //
// ./src/components/Journal2/Journals.js